
import { apiConfig } from '@/lib/env';
import { apiClient } from '@/lib/apiClient';

/**
 * Get access token for Twilio Voice SDK with live backend integration
 */
export const getAccessToken = async (
  metadata?: { userId?: number; leadId?: number; contactId?: number }
): Promise<string> => {
  try {
    const tokenUrl = `${apiConfig.baseUrl}/twilio/token`;
    console.log('🎙️ Requesting Twilio access token from live backend:', tokenUrl);
    console.log('🎙️ Environment context:', {
      mode: import.meta.env.MODE,
      prod: import.meta.env.PROD,
      baseUrl: apiConfig.baseUrl,
      timestamp: new Date().toISOString()
    });

    const requestPayload = {
      identity: 'browser-client',
      ...(metadata?.userId ? { user_id: metadata.userId } : {}),
      ...(metadata?.leadId ? { lead_id: metadata.leadId } : {}),
      ...(metadata?.contactId ? { lead_contact_id: metadata.contactId } : {})
    };
    
    const data = await apiClient.request<{ token: string }>('/twilio/token', {
      method: 'POST',
      body: JSON.stringify(requestPayload),
      context: { category: 'system/utility', page: 'twilio', key: 'twilio-token' },
    });

    console.log('✅ Successfully received Twilio access token from live backend');
    console.log('🎙️ Token data structure:', { hasToken: !!data.token, tokenPrefix: data.token?.substring(0, 20) + '...' });
    
    return data.token;
  } catch (error) {
    console.error('❌ Error getting access token from live backend:', error);
    
    if (error instanceof Error && error.message.includes('fetch')) {
      console.error('🌐 Network connectivity issue - check if backend is accessible');
      throw new Error('Unable to connect to Twilio backend. Please verify your Python API server is running and accessible.');
    }
    
    throw error as any;
  }
};
